import Security from './containers/Security';

export default Security;
